import * as classnames from 'classnames'
import * as React from 'react'

import SafeInnerHtml from '../../../../shared/components/safeInnerHtml'

import * as styles from './tutorialPost.module.css'

interface IProps {
  imgSrc: string
  title: string
  link: string
  description: string
  hideOnMobile?: boolean
}

const TutorialPost = ({
  imgSrc,
  title,
  link,
  description,
  hideOnMobile
}: IProps) => {
  const rootClassNames = classnames(styles.root, {
    [styles.hideOnMobile]: hideOnMobile
  })
  return (
    <article className={rootClassNames}>
      <header>
        <a href={link}>
          <img alt={title} src={imgSrc} className={styles.img} />
        </a>
        <a href={link} className={styles.title}>
          {title}
        </a>
      </header>
      <section className={styles.description}>
        <SafeInnerHtml html={description} />
      </section>
    </article>
  )
}

export default TutorialPost
